import React, { useEffect } from "react";
import { useProjectData } from "../../projects/ProjectDataContext";
import { useProjects } from "../../auth/ProjectContext";

function loadStyle(href: string) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

function loadScript(src: string) {
  return new Promise<void>((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve();
    document.body.appendChild(s);
  });
}

export default function CalendarView() {
  const { currentProject } = useProjects();
  const { projects } = useProjectData();
  const project = projects.find((p) => p.id === currentProject?.id);

  useEffect(() => {
    loadStyle("https://cdn.jsdelivr.net/npm/fullcalendar@6.1.8/main.min.css");
    loadScript("https://cdn.jsdelivr.net/npm/fullcalendar@6.1.8/index.global.min.js").then(() => {
      const fc = (window as any).FullCalendar;
      if (!fc || !project) return;
      const calendarEl = document.getElementById("calendar");
      if (!calendarEl) return;
      const calendar = new fc.Calendar(calendarEl, {
        initialView: "dayGridMonth",
        events: project.tasks.map((t) => ({ title: t.name, start: t.dueDate }))
      });
      calendar.render();
    });
  }, [project]);

  return (
    <div style={{ padding: "1rem" }}>
      <div id="calendar" />
    </div>
  );
}
